import React from 'react'

function TenderTextSwivel() {
  return (
    <embed src="\pdfs\EAT1.2.3.1_DW-V2_Swivel_jet_nozzle_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSwivel